/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JobSummary { 
    /**
     * The job id that uniquely identifies the previously submitted job
     */
    id: string;
    /**
     * The namespace of the job
     */
    namespace?: string;
    /**
     * The name of the job
     */
    jobName: string;
    /**
     * The start time of the job
     */
    startTime: Date;
    /**
     * The end time of the job. It is not returned for a job in RUNNING state
     */
    endTime?: Date;
    /**
     * The status of the job. One of the following values: RUNNING, COMPLETED
     */
    status?: JobSummary.StatusEnum;
    /**
     * The number of exceptions
     */
    totalExceptions?: number;
}
export namespace JobSummary {
    export type StatusEnum = 'RUNNING' | 'SUSPENDED' | 'COMPLETED';
    export const StatusEnum = {
        RUNNING: 'RUNNING' as StatusEnum,
        SUSPENDED: 'SUSPENDED' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum
    };
}
